import React, {useState} from 'react';
import PropTypes from 'prop-types';

import FormTextInput from '../FormTextInput';

const phoneRegex = /^06\d{8}$/i;

const PhoneNumberInput = ({label, value, onChange}) => {
  const [phoneNumber, setPhoneNumber] = useState(value);
  const [phoneError, setPhoneError] = useState(false);

  const phoneMissing = !phoneNumber?.length;
  const phoneInvalid = !!phoneNumber?.length && !phoneRegex.test(phoneNumber);
  let errorMessage = null;

  if (phoneMissing) {
    errorMessage = 'Mobiele telefoonnummer is verplicht';
  } else if (phoneInvalid) {
    errorMessage = 'Ongeldige waarde mobiele telefoonnummer';
  }

  return (
    <FormTextInput
      value={phoneNumber}
      onChangeText={setPhoneNumber}
      onEndEditing={() => {
        const valid = !phoneNumber || phoneRegex.test(phoneNumber);
        setPhoneError(!valid);
        if (valid) {
          onChange(phoneNumber);
        }
      }}
      label={label}
      hasError={phoneError}
      errorMessage={errorMessage}
      digits={0}
      inputProps={{
        maxLength: 10,
        keyboardType: 'numeric',
      }}
    />
  );
};

PhoneNumberInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default PhoneNumberInput;
